import { type FC, useCallback } from 'react';

import { Icon, type IconProps } from '@vakantiesnl/components/src/atoms/Icon';
import { Link } from '@vakantiesnl/components/src/atoms/Link';
import { type Location } from '@vakantiesnl/types/src/elasticsearch/entities';

import { useCustomStyles } from './LocationBreadCrumbs.style';

type LocationProps = {
	text: string;
	to?: string;
	destinationType?: Location['destinationType'];
};

export type LocationBreadCrumbProps = {
	location: LocationProps[];
	noLinks?: boolean;
	handleBreadcrumbClick?: (
		destinationUrl: string,
		destinationType?: Location['destinationType'],
		isAccoHeader?: boolean,
		atomType?: string,
		label?: string,
	) => void;
	breadCrumbClassName?: string;
	iconSize?: IconProps['size'];
};

export const LocationBreadCrumbs: FC<LocationBreadCrumbProps> = ({
	location,
	noLinks,
	handleBreadcrumbClick,
	breadCrumbClassName,
	iconSize,
}) => {
	const { classes, cx } = useCustomStyles();

	const linkOnClick = useCallback(
		(locationItem: LocationProps) => () => {
			if (locationItem.to)
				handleBreadcrumbClick?.(
					locationItem.to,
					locationItem.destinationType,
					true,
					'breadcrumb',
					locationItem.text,
				);
		},
		[handleBreadcrumbClick],
	);

	return (
		<div className={cx(classes.breadcrumbs, breadCrumbClassName)}>
			<Icon type="destination" size={iconSize} />
			<span className={classes.breadcrumbsWrapper}>
				{location.map((locationItem, i) => {
					if (!noLinks && locationItem.to)
						return (
							<Link
								key={locationItem.text + i}
								href={locationItem.to}
								className={classes.location}
								onClick={linkOnClick(locationItem)}
							>
								{locationItem.text}
							</Link>
						);
					return (
						<span key={locationItem.text + i} className={classes.location}>
							{locationItem.text}
						</span>
					);
				})}
			</span>
		</div>
	);
};
